(function () {

	'use strict';

	/*global $:true */

	let cologicGallery = {

		initGallery: function () {

			// let that = this;
            //
			// this.showToTop();
			// this.setBurger();
			// this.enableAccordion();
			// // this.navigationHandling();
			// // this.setYoutubeBox();
            //
			// $('.toTopWrapper').click(this.pageToTop);
			// // $(window).scroll(function () {
			// // 	that.setBackgroundImages();
			// // 	that.showToTop();
			// // });
			// // setTimeout(function () {
			// // 	that.setBackgroundImages()
			// // }, 1500);
            //
			// this.equalHeight();

		},

		//--------------------------------------

        someCallback: function (args) {
            var currentSlideNumber = args.currentSlideNumber;
            if($('.sliderButton').length>0){
                $('#sliderButtonContainer-'+args.sliderContainerObject.data('tag-elem-nr')+' .sliderButton').removeClass('selected');
                $('#sliderButtonContainer-'+args.sliderContainerObject.data('tag-elem-nr')+' .sliderButton:eq(' + (args.currentSlideNumber - 1) + ')').addClass('selected');
                // $('#'+args.sliderContainerObject.attr('id')+' .sliderButton').removeClass('selected');
                // $('#'+args.sliderContainerObject.attr('id')+' .sliderButton:eq(' + (args.currentSlideNumber - 1) + ')').addClass('selected');

            }

        },


		initGallerySlider: function (_sliderId, gotoHashImgNo=1, _arrowCont) {
            let that = this;
            if ($(_sliderId).length <= 0) return false;
            // if (gotoHashImgNo === undefined || gotoHashImgNo <= 0)
            //     gotoHashImgNo = 1;
            //console.log("* "+gotoHashImgNo+" *");
            $(_sliderId).iosSlider({
                snapToChildren: true,
                scrollbar: false,
                scrollbarHide: true,
                desktopClickDrag: true,
                autoSlide: false,
                startAtSlide: gotoHashImgNo,
                navPrevSelector: $(_arrowCont+' .prev'),
                navNextSelector: $(_arrowCont+' .next'),
                onSlideChange: that.someCallback,
                infiniteSlider: true,
                responsiveSlideContainer: true,
                responsiveSlides: true

            });
            console.log($(_sliderId +' .prev'));

        },
        // initSlider: function(_sliderId, _arrowCont){
        //     // initSlider: function(_sliderId, _sliderButton, _arrowCont){
        //     $(_sliderId).iosSlider({
        //         snapToChildren: true,
        //         scrollbar: false,
        //         scrollbarDrag: false,
        //         scrollbarHeight: '15px',
        //         // navSlideSelector: $(_sliderButton),
        //         navPrevSelector: $(_arrowCont+' .slideLeft'),
        //         navNextSelector: $(_arrowCont+' .slideRight'),
        //         autoSlide: false,
        //         autoSlideTimer: 5000,
        //         autoSlideTransTimer: 500,
        //         desktopClickDrag: true,
        //         infiniteSlider: true,
        //         responsiveSlideContainer: true,
        //         responsiveSlides: true,
        //         onSlideChange: cologic.slideChange,
        //         onSliderResize: cologic.sliderUpdate
        //     });
        // },

		initMBBoxSlider: function (_sliderId, gotoHashImgNo = 1, _elemNr) {
            let that = this;
            let sliderButtons = '#sliderButtonContainer-'+ _elemNr + ' .sliderButton';
            console.log('in Slider');
            if ($(_sliderId).length <= 0) return false;
            // if (gotoHashImgNo === undefined || gotoHashImgNo <= 0)
            //     gotoHashImgNo = 1;
            //console.log("* "+gotoHashImgNo+" *");
            $(_sliderId).iosSlider({
                snapToChildren: true,
                scrollbar: false,
                scrollbarHide: true,
                desktopClickDrag: true,
                autoSlide: true,
                autoSlideTimer: 5000,
                autoSlideTransTimer: 2000,
                startAtSlide: gotoHashImgNo,
                navSlideSelector: $(sliderButtons),
                navPrevSelector: $('.prev'),
                navNextSelector: $('.next'),
                onSlideChange: that.someCallback,
                infiniteSlider: true,
                responsiveSlideContainer: true,
                responsiveSlides: true,
                onSliderResize: cologic.sliderUpdate,
                onSliderLoaded: cologic.sliderLoaded
            });
		},

		initMBGallerySlider: function (_sliderId, gotoHashImgNo) {
            let that = this;
            if ($(_sliderId).length <= 0) return false;
            if (gotoHashImgNo === undefined || gotoHashImgNo <= 0)
                gotoHashImgNo = 1;
            //console.log("* "+gotoHashImgNo+" *");
            $(_sliderId).iosSlider({
                snapToChildren: true,
                scrollbar: false,
                scrollbarHide: true,
                desktopClickDrag: true,
                autoSlide: true,
                autoSlideTimer: 5000,
                autoSlideTransTimer: 2000,
                startAtSlide: gotoHashImgNo,
                // navPrevSelector: $('.prev'),
                // navNextSelector: $('.next'),
                onSlideChange: that.someCallback,
                infiniteSlider: true,

            });
		},

        openGallery: function (_elem) {
            let that = this;
            let currentPos = parseInt($(_elem).offset().top);
            let input = JSON.parse($(_elem).attr('data-slideItems'));
            let output = '<div class="galWrapper"><div id="gal' + input.slideId + '" class = "iosSliderGal"><div class = "slider">';
            for(let i in input.slideEl) {
                var slideNr = (parseInt(i) + parseInt(1));
                output += '<div class = "slide item' + slideNr + '"style="background-image:url(\'' + input.slideEl[i] + '\')"></div>';
            }
            output += '</div></div><div class="navButtons"><div class="prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div><div class="next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div></div><div class="exit" onclick="closeSlider(this,' + currentPos + ')"></div></div>';
            $(_elem).parent().parent().parent().parent().parent().parent().parent().children().toggleClass('hideElem');
            $(_elem).parent().parent().parent().parent().parent().parent().parent().prepend(output);
            setTimeout(function () {
                that.initGallerySlider('#gal' + input.slideId);

            }, 300);

		},

        openGalleryBig: function (_elem, _galId, _itemId) {
            let that = this;
            let tempGoTo = 1;
            let bg = '';
            let currentPos = parseInt($(_elem).offset().top);
            let itemNr = $(_elem).attr('data-slideItem');
            let colorClasses = $(_elem).parent().parent().parent().data('colorclass');
            let output = '<div class="galWrapper ' + colorClasses + '"><div id="gal' + _galId + '" class ="iosSliderGal"><div class="slider">';
            $('#' + _galId + ' .thumbItem').each(function (index, value) {
                bg = $(this).data('path');
                bg = bg.replace('thumbs', 'big');
                // itemNr = index;
                itemNr = $(this).attr('data-slideItem');
                if(itemNr == _itemId){
                    tempGoTo = index +1;
                }
                output += '<img class="slide item' + itemNr + '"src="' + bg + '" />';
            });
            output += '</div></div><div class="navButtons" id="navButtons' + _galId + '"><div class="prev"><i class="icon-left-arrow" aria-hidden="true"></i></div><div class="next"><i class="icon-right-arrow" aria-hidden="true"></i></div></div><div class="exit" onclick="cologic.closeGalSlider(this,' + currentPos + ')"><i class="icon-kreuz" aria-hidden="true"></i></div></div>';
            $(_elem).parent().parent().children().toggleClass('hideElem');
            $(_elem).parent().parent().parent().parent().prepend(output);
            setTimeout(function () {
                that.initGallerySlider('#gal' + _galId, tempGoTo,'#navButtons' + _galId,);
            }, 300);
		},

        openGalleryBigFromSlider: function (_elem, _galId, _itemId) {
            let that = this;
            let tempGoTo = 1;
            let bg = '';
            let currentPos = parseInt($(_elem).offset().top);
            let itemNr = $(_elem).attr('data-slideItem');
            let colorClasses = $(_elem).parent().parent().parent().data('colorclass');
            let output = '<div class="galWrapper ' + colorClasses + '"><div id="gal' + _galId + '" class ="iosSliderGal"><div class="slider">';
            $('#' + _galId + ' .thumbItem').each(function (index, value) {
                bg = $(this).data('path');
                bg = bg.replace('thumbs', 'big');
                // itemNr = index;
                itemNr = $(this).attr('data-slideItem');
                if(itemNr == _itemId){
                    tempGoTo = index +1;
                }
                output += '<img class="slide item' + itemNr + '"src="' + bg + '" />';
            });
            output += '</div></div><div class="navButtons"><div class="prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div><div class="next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div></div><div class="exit" onclick="cologic.closeGalSlider(this,' + currentPos + ')"><i class="fa fa-close" aria-hidden="true"></i></div></div>';
            $(_elem).parent().parent().parent().children().toggleClass('hideElem');
            $(_elem).parent().parent().parent().parent().parent().prepend(output);
            setTimeout(function () {
                that.initGallerySlider('#gal' + _galId, tempGoTo);
            }, 300);
		},

        openGalleryInner: function (_elem) {
            let that = this;
            let currentPos = parseInt($(_elem).offset().top);
            let input = JSON.parse($(_elem).attr('data-slideItems'));
            let output = '<div class="galWrapper"><div id="gal' + input.slideId + '" class = "iosSliderGal"><div class = "slider">';
            for(let i in input.slideEl) {
                let slideNr = (parseInt(i) + parseInt(1));
                //var cleanTxt = decodeURI(input.slideTxt[i]);
                let cleanTxt = input.slideTxt[i];
                cleanTxt = decodeURIComponent(cleanTxt.replace(/\+/g, ' '));

                output += '<div class = "slide item' + slideNr + '"style="background-image:url(\'' + input.slideEl[i] + '\')"><p class="tSliderTxt">' + cleanTxt + '</p></div>';
            }
            output += '</div></div><div class="navButtons"><div class="prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div><div class="next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div></div><div class="exit" onclick="cologic.closeSlider(this,' + currentPos + ')"></div></div>';
            $(_elem).parent().parent().parent().parent().parent().parent().parent().children().toggleClass('hideElem');
            $(_elem).parent().parent().parent().parent().parent().parent().parent().prepend(output);
            setTimeout(function () {
                that.initGallerySlider('#gal' + input.slideId);

            }, 300);

        },

		//---------------------------------------------------------

        closeSlider: function (_elem, currentPos) {
            $(_elem).parent().parent().children().toggleClass('hideElem');
            $(_elem).parent().remove();
            this.scrollToY(currentPos);
		},


        closeGalSlider: function (_elem, currentPos) {
            $(_elem).parent().remove();
            $('.hideElem').toggleClass('hideElem');
            this.scrollToY(currentPos);
		},


	};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicGallery);
}());